import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from "antd";
import { useDeviceType } from "../../hooks/useDeviceType.js";
import { colors } from "../../styles/colors.js";
import { DeviceType } from "../../types/device/device.js";
const EditModal = ({ open, onCancel, children, ...restProps })=>{
    const device = useDeviceType();
    return /*#__PURE__*/ _jsx(Modal, {
        open: open,
        onCancel: onCancel,
        width: "90%",
        style: {
            maxHeight: DeviceType.isBigScreen(device) ? "85vh" : "75vh",
            overflowY: "auto",
            backgroundColor: colors.main.background
        },
        centered: true,
        destroyOnClose: true,
        ...restProps,
        children: children
    });
};
export { EditModal };
